/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Backend_Development_Architect_Detail9Inputs */

const en_svc_backend_development_architect_detail9 = /** @type {(inputs: Svc_Backend_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right framework for the job, structured, lightweight, or AI-heavy.`)
};

const ar_svc_backend_development_architect_detail9 = /** @type {(inputs: Svc_Backend_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإطار الصحيح للمهمة, منظم أو خفيف أو ثقيل بالذكاء الاصطناعي.`)
};

const bn_svc_backend_development_architect_detail9 = /** @type {(inputs: Svc_Backend_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কাজের উপযুক্ত ফ্রেমওয়ার্ক, স্ট্রাকচার্ড, লাইটওয়েট বা AI-ভারি।`)
};

const de_svc_backend_development_architect_detail9 = /** @type {(inputs: Svc_Backend_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das richtige Framework für die Aufgabe, strukturiert, leichtgewichtig oder KI-lastig.`)
};

const es_svc_backend_development_architect_detail9 = /** @type {(inputs: Svc_Backend_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El framework adecuado para cada caso: estructurado, ligero o con mucha IA.`)
};

const fr_svc_backend_development_architect_detail9 = /** @type {(inputs: Svc_Backend_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le bon framework selon le cas, structuré, léger ou lourd en IA.`)
};

const pt_svc_backend_development_architect_detail9 = /** @type {(inputs: Svc_Backend_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O framework certo para cada caso: estruturado, leve ou com muita IA.`)
};

const zh_svc_backend_development_architect_detail9 = /** @type {(inputs: Svc_Backend_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选合适的技术栈：规整的、轻量的还是重 AI 的。`)
};

const tr_svc_backend_development_architect_detail9 = /** @type {(inputs: Svc_Backend_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İşe uygun framework: yapısal, hafif ya da AI ağırlıklı.`)
};

const ru_svc_backend_development_architect_detail9 = /** @type {(inputs: Svc_Backend_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подходящий фреймворк под задачу: структурный, лёгкий или ИИ-хэви.`)
};

const pl_svc_backend_development_architect_detail9 = /** @type {(inputs: Svc_Backend_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Właściwy framework do roboty: ustrukturyzowany, lekki albo AI-heavy.`)
};

/**
* | output |
* | --- |
* | "Right framework for the job, structured, lightweight, or AI-heavy." |
*
* @param {Svc_Backend_Development_Architect_Detail9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_backend_development_architect_detail9 = /** @type {((inputs?: Svc_Backend_Development_Architect_Detail9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Backend_Development_Architect_Detail9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_backend_development_architect_detail9(inputs)
	if (locale === "bn") return bn_svc_backend_development_architect_detail9(inputs)
	if (locale === "de") return de_svc_backend_development_architect_detail9(inputs)
	if (locale === "es") return es_svc_backend_development_architect_detail9(inputs)
	if (locale === "fr") return fr_svc_backend_development_architect_detail9(inputs)
	if (locale === "pt") return pt_svc_backend_development_architect_detail9(inputs)
	if (locale === "zh") return zh_svc_backend_development_architect_detail9(inputs)
	if (locale === "tr") return tr_svc_backend_development_architect_detail9(inputs)
	if (locale === "ru") return ru_svc_backend_development_architect_detail9(inputs)
	if (locale === "pl") return pl_svc_backend_development_architect_detail9(inputs)
	return en_svc_backend_development_architect_detail9(inputs)
});
export { svc_backend_development_architect_detail9 as "svc_backend-development_ARCHITECT_detail" }